import React from 'react';

export const CorporateTeamSection = ({ t, team }) => {
  return (
    <section id="team" className="py-12 sm:py-20 bg-gray-50" data-testid="home-team-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" data-testid="home-team-title">{t('team.title')}</h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600" data-testid="home-team-subtitle">{t('team.subtitle')}</p>
          <p className="text-sm sm:text-base text-gray-500 mt-2 max-w-2xl mx-auto" data-testid="home-team-description">{t('team.description')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 max-w-4xl mx-auto" data-testid="home-team-grid">
          {team.map((member) => (
            <div key={member.name} className="bg-white rounded-xl shadow-lg overflow-hidden text-center hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2" data-testid={`home-team-card-${member.name.replace(/\s+/g, '-').toLowerCase()}`}>
              <div className="relative h-64 sm:h-80 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  decoding="async"
                  style={member.name === 'Roberto Hasebe' ? { objectPosition: 'center 20%' } : {}}
                  data-testid={`home-team-image-${member.name.replace(/\s+/g, '-').toLowerCase()}`}
                />
              </div>

              <div className="p-5 sm:p-6">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2" data-testid={`home-team-name-${member.name.replace(/\s+/g, '-').toLowerCase()}`}>{member.name}</h3>
                <p className="text-base sm:text-lg text-blue-600 font-semibold" data-testid={`home-team-role-${member.name.replace(/\s+/g, '-').toLowerCase()}`}>{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
